import { ComponentRef, Inject, Injectable, Injector, ViewContainerRef, createNgModule } from '@angular/core';

import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { I18N_FEATURE_NAMESPACE } from '../constants/i18next.config';
import { ModalComponent as IModalComponent } from '../modal/modal.component';

@Injectable({
  providedIn: 'root'
})
export class ProductBarcodeScannerModalLoaderService {
  constructor(
    private readonly injector: Injector,
    @Inject(I18NEXT_SERVICE) private readonly i18NextService: ITranslationService
  ) {}

  async loadAndOpen(viewContainerRef: ViewContainerRef, reloadOnClose = false): Promise<void> {
    const ref = await this.load(viewContainerRef);

    ref.instance.open(reloadOnClose);
  }

  async load(viewContainerRef: ViewContainerRef): Promise<ComponentRef<IModalComponent>> {
    const { ProductBarcodeScannerFeatureModule, ModalComponent } = await import(
      '../product-barcode-scanner-feature.module'
    );
    await this.i18NextService.loadNamespaces([I18N_FEATURE_NAMESPACE]);

    const ref = viewContainerRef.createComponent(ModalComponent, {
      ngModuleRef: createNgModule(ProductBarcodeScannerFeatureModule, this.injector)
    });

    ref.changeDetectorRef.detectChanges();

    return ref;
  }
}
